<template>
    <div :tabindex="tabindex" :style="{
        'font-family': fontFamily,
        'font-size': fontSize ?? '15px',
        'font-weight': '400',
        'max-width': '100%',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
    }">
        <div v-if="showSelectedAsBox && selectedValues.size > 0" class="selected-box">
            <template v-for="option in selectedValues.values()">
                <div class="selected-box__label">
                    <span>
                        {{ option.label }}
                    </span>
                    <div class="selected-box__label-remove" @click="(e) => {
                        e.stopPropagation();
                        removeOption(option.option.id);
                    }">
                        <span class="pi pi-times p-button-icon">
                        </span>
                    </div>
                </div>
            </template>
        </div>
        <div v-else class="selected-text">
            {{ formattedValue }}
        </div>
    </div>
</template>
<script src="./app-dropdown-selected.ts"></script>

<style>
.selected-box {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.selected-box__label {
    display: flex;
    border: 1px solid #E5E7EB;
    padding: 2px 4px;
    border-radius: 4px;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
}

.selected-box__label-remove {
    cursor: pointer;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border-radius: 4px;
}

.selected-box__label-remove:hover {
    background-color: #d4e4f4;
}
</style>
